import { Component, Inject, signal } from '@angular/core';
import { Internship } from '../../models/internship';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CompanyService } from '../../service/company.service';
import { ConfirmationnDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { AvailableInternship } from '../../models/availableInternship.models';
import { CityDto, CountryDto } from '../../models/company.model';
import { MatIcon } from "@angular/material/icon";
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, MatAccordion } from "@angular/material/expansion";
import { MatButtonModule } from "@angular/material/button";
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-view-internship-dialog',
  standalone: true,
  templateUrl: './view-internship-dialog.component.html',
  styleUrl: './view-internship-dialog.component.css',
  imports: [MatIcon, CommonModule, FormsModule, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, MatAccordion, MatButtonModule, TranslateModule]
})
export class ViewInternshipDialogComponent {

  isEditable: boolean = false; 
  canEdit: boolean = true;
  availableInternships: AvailableInternship[] = [];
  countries: CountryDto[] = [];
  cities: CityDto[] = [];

  constructor(private dialogRef: MatDialogRef<ViewInternshipDialogComponent>, private companyService: CompanyService,
      @Inject(MAT_DIALOG_DATA) public internshipData: Internship, private dialog: MatDialog,
      private translate: TranslateService

  ) {
    // Disabilita la modifica se lo status è "Ongoing" o "Completed"
    this.canEdit = this.internshipData.status !== 'Ongoing' && this.internshipData.status !== 'Completed';
  }

  ngOnInit(event : any): void {

    console.log('Dati tirocinio ricevuti:', this.internshipData);

    this.companyService.getAvailableInternships().subscribe({
      next: (res) => {
        this.availableInternships = res;
        
        // Carica department, country e city dall'availableInternship corrispondente
        // Usa availableInternshipId se esiste, altrimenti cerca per titolo
        const matchingInternship = res.find(i => 
          i.id === this.internshipData.availableInternshipId || 
          i.title === this.internshipData.availableInternshipTitle
        );
        
        if (matchingInternship) {
          console.log('Internship trovato:', matchingInternship);
          // Salva l'ID per gli aggiornamenti futuri
          this.internshipData.availableInternshipId = matchingInternship.id;
          // Sovrascrivi sempre con gli oggetti dall'API
          this.internshipData.availableInternshipDepartment = matchingInternship.department;
          this.internshipData.availableInternshipCountry = matchingInternship.country;
          this.internshipData.availableInternshipCity = matchingInternship.city;
          
          console.log('Dati aggiornati:', this.internshipData);
        } else {
          console.warn('Nessun internship trovato per ID:', this.internshipData.availableInternshipId, 'o titolo:', this.internshipData.availableInternshipTitle);
        }
      },
      error: (err) => {
        console.error('Errore nel recupero tirocini disponibili', err);
      }
    });

  }
    
  onInternshipSelected(event: any) {
  const selectedId = +event.target.value; // converti in numero
  const selectedInternship = this.availableInternships.find(i => i.id === selectedId);
  if (selectedInternship) {
    this.internshipData.availableInternshipId = selectedInternship.id;
    this.internshipData.availableInternshipTitle = selectedInternship.title;
    this.internshipData.availableInternshipPosition = selectedInternship.position;
    this.internshipData.availableInternshipDepartment = selectedInternship.department;
    this.internshipData.availableInternshipCountry = selectedInternship.country;
    this.internshipData.availableInternshipCity = selectedInternship.city;
    console.log('Internship selezionato:', selectedInternship);
  }
  }
  

  onCancel(): void {
    this.dialogRef.close();
  }

  
   step = signal(0);

  setStep(index: number) {
    this.step.set(index);
  }

  nextStep() {
    this.step.update(i => i + 1);
  }

  prevStep() {
    this.step.update(i => i - 1);
  }

  toggleCancel() {
    // Se annulli, ritorna alla visualizzazione e puoi ripristinare i dati originali se vuoi
    this.isEditable = false;
  }

  toggleEdit() {
  if (this.isEditable) {
    // Se stiamo salvando, qui puoi chiamare il service per aggiornare i dati
    this.updateInternship();
  }
  this.isEditable = !this.isEditable;
}

enableEdit() {
  if (this.canEdit) {
    this.isEditable = true;
  }
}

updateInternship(): void {
    const dialogRef = this.dialog.open(ConfirmationnDialogComponent, {
    width: '400px',
    data: { message: this.translate.instant('internship-dialog.confirm-save') }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result){
        if (!this.internshipData.id) {
          console.error('ID del tirocinante mancante');
          return;
        }
        
        this.companyService.updateInternship(this.internshipData.id, this.internshipData).subscribe({
          next: (res) => {
            console.log('Tirocinante aggiornato con successo:', res);
            this.dialogRef.close(true);
          },
          error: (err) => {
            console.error('Errore durante aggiornamento:', err);
            alert(this.translate.instant('internship-dialog.errors.update'));
          }
        });
      }
    });
  }
}
